import React from "react";
import { Carousel } from "primereact/carousel";

import slide1 from "../assets/banner/slider-1.jpg";
import slide2 from "../assets/banner/slider-2.jpg";
import slide3 from "../assets/banner/slider-3.jpg";
import slide4 from "../assets/banner/slider-4.jpg";
import slide5 from "../assets/banner/slider-5.jpg";

export default function HomeBanner() {
  const slides = [
    {
      image: slide1,
      title: "Welcome to PESIL InfoSol",
      description:
        "Implement Systems Engineering Process using IBM Jazz, OSLC Applications, SysML.",
    },
    {
      image: slide2,
      // title: "ELM Applications",
      description: "IBM DOORS Next Generation (DNG).",
    },
    {
      image: slide3,
      // title: "ELM Applications",
      description: "IBM Rhapsody.",
    },
    {
      image: slide4,
      // title: "ELM Applications",
      description: "Engineering Workflow Management (EWM).",
    },
    {
      image: slide5,
      // title: "ELM Applications",
      description: "Engineering Test Management (ETM).",
    },
  ];

  const slideTemplate = (item) => {
    return (
      <div
        style={{
          height: "300px",
          backgroundImage: `url(${item.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
        }}
      >
        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
          }}
        ></div>

        {/* Content */}
        <div style={{ position: "relative", textAlign: "center" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
            {item.title}
          </h1>

          <p style={{ fontSize: "1.2rem", marginBottom: "1.5rem" }}>
            {item.description}
          </p>
        </div>
      </div>
    );
  };

  return (
    <Carousel
      value={slides}
      itemTemplate={slideTemplate}
      numVisible={1}
      numScroll={1}
      circular
      autoplayInterval={4000}
      showIndicators
      showNavigators
    />
  );
}
